import { Server, Users, Sparkles, Layers } from "lucide-react";
import { cn } from "@/lib/utils";
import { ROUTE_LABEL, type RouteType } from "@/lib/genrl";

const STYLE: Record<RouteType, { cls: string; Icon: typeof Server }> = {
  INTERNAL:    { cls: "border-[var(--success)]/30 bg-[var(--success)]/10 text-[var(--success)]", Icon: Server },
  PEER:        { cls: "border-primary/30 bg-primary/10 text-primary",                              Icon: Users },
  GENRL_NATIVE:{ cls: "border-[var(--accent)]/30 bg-[var(--accent)]/10 text-[var(--accent)]",      Icon: Sparkles },
  HYBRID:      { cls: "border-[var(--warning)]/30 bg-[var(--warning)]/10 text-[var(--warning)]",   Icon: Layers },
};

export function RouteBadge({
  routeType,
  size = "sm",
  className,
}: {
  routeType: RouteType;
  size?: "sm" | "md";
  className?: string;
}) {
  const { cls, Icon } = STYLE[routeType];
  const dim = size === "md" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
  const ic = size === "md" ? "h-3.5 w-3.5" : "h-3 w-3";
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full border font-medium uppercase tracking-wider", dim, cls, className)}>
      <Icon className={ic} />
      {ROUTE_LABEL[routeType]}
    </span>
  );
}
